import { useAutoSwitchFromExpressShipping } from "../../hooks/use-auto-switch-from-express-shipping";

export const MMExpressShippingGuard = () => {
  useAutoSwitchFromExpressShipping();
  return null;
};
